import React, { FC, ReactElement } from 'react';
import { useQuery } from '@apollo/client';
import { useSettings } from '../../../hooks/useSettings';
import {
  Country,
  Language,
  GetMarketingAssetQuery,
  GetMarketingAssetQueryVariables,
} from '../../../../../__generated__/loma';
import getMarketingAssetQuery from './graphql';
import Asset from './Asset';

export interface BlockAssetWrapperProps {
  featureId: string;
  featureName?: string;
  fixedPanelHeight?: string;
  localeLanguage?: Language;
  localeCountry?: Country;
  templateRenderingContext?: unknown;
}

const BlockAssetWrapper: FC<BlockAssetWrapperProps> = ({
  featureName,
  featureId,
  fixedPanelHeight,
  localeLanguage,
  localeCountry,
  templateRenderingContext,
}): ReactElement | null => {
  const { assets } = useSettings();
  const { [featureId]: assetFeature } = assets || {};
  const { assetId = '' }: { assetId: string } = assetFeature || {};

  const { data: { getMarketingAsset: asset } = {} } = useQuery<
    GetMarketingAssetQuery,
    GetMarketingAssetQueryVariables
  >(getMarketingAssetQuery, {
    skip: !assetId,
    variables: {
      id: assetId,
      language: localeLanguage,
      country: localeCountry,
    },
  });

  if (!assetId || !asset) return null;

  return (
    <Asset
      featureName={featureName}
      assetId={assetId}
      asset={asset}
      fixedPanelHeight={fixedPanelHeight}
      templateRenderingContext={templateRenderingContext}
    />
  );
};

export default BlockAssetWrapper;
